import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const LINKS = [
  { id: 'about', label: 'Story', testId: 'nav-about' },
  { id: 'services', label: 'Offerings', testId: 'nav-services' },
  { id: 'journal', label: 'Journal', testId: 'nav-journal' },
  { id: 'contact', label: 'Begin', testId: 'nav-contact' },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el && window.__lenis) window.__lenis.scrollTo(el, { duration: 2.2 });
    else if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav
        data-testid="main-nav"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled ? 'bg-[#F5F0E8]/85 backdrop-blur-md' : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between px-6 md:px-16 py-5 md:py-7">
          <button
            data-testid="nav-logo"
            onClick={() => scrollTo('hero')}
            className={`font-serif-display text-base sm:text-lg md:text-xl tracking-[0.14em] sm:tracking-[0.18em] uppercase transition-colors duration-700 ${scrolled ? 'text-[#2C2C2A]' : 'text-[#2C2C2A]'}`}
          >
            Rise <span className="italic font-light text-[#1A4D38]">with</span> Presence
          </button>
          <div className="hidden md:flex items-center gap-10 text-xs uppercase tracking-[0.2em] text-[#2C2C2A]/70 font-normal">
            {LINKS.map((l) => (
              <button key={l.id} data-testid={l.testId} onClick={() => scrollTo(l.id)} className="link-underline hover:text-[#1A4D38] transition-colors duration-500">
                {l.label}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-menu-toggle"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="md:hidden p-2 -mr-2 text-[#2C2C2A]"
          >
            <Menu size={22} strokeWidth={1.5} />
          </button>
        </div>
      </nav>

      <div
        data-testid="mobile-menu"
        className={`fixed inset-0 z-[60] md:hidden bg-[#F5F0E8] flex flex-col transition-opacity duration-500 ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5">
          <p className="font-serif-display text-base tracking-[0.14em] uppercase text-[#2C2C2A]">
            Rise <span className="italic text-[#1A4D38]">with</span> Presence
          </p>
          <button data-testid="nav-menu-close" aria-label="Close menu" onClick={() => setOpen(false)} className="p-2 -mr-2 text-[#2C2C2A]">
            <X size={22} strokeWidth={1.5} />
          </button>
        </div>
        <div className="flex-1 flex flex-col justify-center px-8 gap-8">
          {LINKS.map((l, i) => (
            <button
              key={l.id}
              data-testid={`mobile-${l.testId}`}
              onClick={() => scrollTo(l.id)}
              className="text-left font-serif-display font-light text-4xl text-[#2C2C2A] hover:text-[#1A4D38] transition-colors duration-500"
              style={{ transitionDelay: open ? `${i * 60}ms` : '0ms' }}
            >
              {l.label}
            </button>
          ))}
        </div>
        <p className="px-8 pb-10 text-[10px] uppercase tracking-[0.3em] text-[#2C2C2A]/40">Come home to yourself.</p>
      </div>
    </>
  );
};

export default Nav;
